module.exports = __webpack_public_path__ + "static/payroll-fbf8674e2f7ce57ea2da342cb171487c.png";